export default __webpack_public_path__ + "static/media/Daniel-Wyatt-Resume.6888d1d4.pdf";